export default {
  /* 游戏名称 */
  gameName: state => state.game.gameInfo.name,
  /* 游戏id */
  gameId: state => state.game.gameInfo.id,
  /* 头部标题 */
  title: state => state.game.title,
  /* 重置项id */
  resetId: state => state.game.resetId
};
